import { render } from "./descriptionTextArea.vue?vue&type=template&id=0defd085"
import script from "./descriptionTextArea.vue?vue&type=script&lang=js"
export * from "./descriptionTextArea.vue?vue&type=script&lang=js"

import "./descriptionTextArea.vue?vue&type=style&index=0&id=0defd085&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__